import axios from '@/config/backend'

export default {
    getForm({ rootState, commit }) {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(`/${rootState.lang}`)
                    .then((response) => {
                        commit('setForm', response.data.form)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            } catch (error) {
                reject(error)
            }
        })
    }
}
